/**
 * Free Gift Modal JavaScript
 * Handles opening and closing of free gift modals
 */

// Function to open the free gift modal
function openFreeGiftModal(cardElement) {
  // Get data from the clicked card
  const giftTitle = cardElement.getAttribute('data-gift-title');
  const giftPrice = cardElement.getAttribute('data-gift-price');
  const giftDescription = cardElement.getAttribute('data-gift-description');
  const giftImage = cardElement.getAttribute('data-gift-image');
  
  // Get modal elements
  const modal = document.getElementById('free-gift-modal');
  const modalTitle = document.getElementById('modal-gift-title');
  const modalPrice = document.getElementById('modal-gift-price');
  const modalDescription = document.getElementById('modal-gift-description');
  const modalImage = document.getElementById('modal-gift-image');
  
  // Check if modal exists
  if (!modal) {
    console.error('Free gift modal not found');
    return;
  }
  
  // Populate modal content
  if (modalTitle) modalTitle.textContent = giftTitle || 'Free Gift';
  if (modalPrice) {
    // Use Shopify money format
    modalPrice.textContent = formatPrice(giftPrice) || '$0.00';
  }
  if (modalDescription) {
    // Use innerHTML to preserve line breaks and basic formatting
    const description = giftDescription || 'No description available';
    modalDescription.innerHTML = description.replace(/\n/g, '<br>');
  }
  if (modalImage) {
    modalImage.src = giftImage || '';
    modalImage.alt = giftTitle || 'Free Gift';
    
    // Debug log to check image URL
    console.log('Modal image URL:', giftImage);
  }
  
  // Debug log to check all data
  console.log('Modal data:', { giftTitle, giftPrice, giftDescription, giftImage });
  
  // Show modal
  modal.style.display = 'flex';
  
  // Prevent body scroll
  document.body.style.overflow = 'hidden';
  
  // Focus trap for accessibility
  modal.focus();
  
  // Add escape key listener
  document.addEventListener('keydown', handleEscapeKey);
}

// Function to close the free gift modal
function closeFreeGiftModal() {
  const modal = document.getElementById('free-gift-modal');
  
  if (modal) {
    modal.style.display = 'none';
    
    // Restore body scroll
    document.body.style.overflow = '';
    
    // Remove escape key listener
    document.removeEventListener('keydown', handleEscapeKey);
  }
}

// Handle escape key to close modal
function handleEscapeKey(event) {
  if (event.key === 'Escape') {
    closeFreeGiftModal();
  }
}

// Format price using Shopify's money format
function formatPrice(priceInCents) {
  if (!priceInCents) return '$0.00';
  
  // Convert cents to dollars/euros
  const price = parseInt(priceInCents) / 100;
  
  // Try to detect currency from Shopify or use a basic format
  // You can customize this based on your shop's currency
  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify.currency.active
    }).format(price);
  }
  
  // Fallback to basic format (customize as needed)
  return price.toFixed(2) + '€';
}

// Initialize modal functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Add click event listeners to all free gift cards
  const freeGiftCards = document.querySelectorAll('.free-gift-card');
  
  freeGiftCards.forEach(card => {
    // Add click handler only for unlocked cards that don't already have onclick
    if (card.classList.contains('free-gift-card--unlocked') && !card.onclick) {
      card.addEventListener('click', function() {
        openFreeGiftModal(this);
      });
    }
  });
  
  // Add click listener to modal background for closing
  const modal = document.getElementById('free-gift-modal');
  if (modal) {
    modal.addEventListener('click', function(e) {
      // Only close if clicking the modal background, not the content
      if (e.target === modal) {
        closeFreeGiftModal();
      }
    });
  }
  
  // Add click listener to close button
  const closeButton = document.querySelector('.free-gift-modal__close');
  if (closeButton) {
    closeButton.addEventListener('click', closeFreeGiftModal);
  }
});

// Make functions available globally for inline onclick handlers
window.openFreeGiftModal = openFreeGiftModal;
window.closeFreeGiftModal = closeFreeGiftModal;